/* eslint-disable  @typescript-eslint/no-explicit-any */
/* jscpd:ignore-start */
import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface Coupon {
    username: string
    token: string
}

const couponModule: Module<any, any> = {
    state: {
        coupons: [],
        totalRows: 0,
    },

    actions: {
        // Add auth headers
        async UpdateCoupon({ dispatch }, coupon: Coupon) {
            await axios.post('/coupons', coupon)
            return await dispatch('GetCoupons')
        },

        async DeleteCoupon({ dispatch }, coupon: Coupon) {
            await axios.delete('/coupons', coupon)
            return await dispatch('GetCoupons')
        },

        async GetCoupons({ commit }, { page, num, search }) {
            // let response = await axios.get("/coupons");
            // Do some caching?

            const filterServerSide = false


            const source = [
                'external',
                'internal',
                'client-customer',
                'testing-purposes',
                'security',
            ]
            // cSpell:enable

            const data = []
            const totalRows = 101
            for (let i = 0; i < totalRows; i++) {
                const updateDate = new Date()
                updateDate.setMinutes(
                    updateDate.getMinutes() - Math.floor(Math.random() * 3000),
                )
                data.push({
                    id: i,
                    source: source[Math.floor(Math.random() * source.length)],
                    claimCount: Math.floor(Math.random() * 100000),
                    status: 'Active',
                    code: 'some_code',
                })
            }

            const response = {
                data: data,
                totalRows: totalRows,
            }

            const coupons = response.data

            let filteredCoupons = coupons

            if (search && search.length && !filterServerSide) {
                const searchLower = search.toLowerCase()
                filteredCoupons = coupons.filter((coupon) => {
                    return (
                        coupon.code.toLowerCase().indexOf(searchLower) > -1 ||
                        coupon.source.toLowerCase().indexOf(searchLower) > -1
                    )
                })
            }

            const indexFrom = (page - 1) * num
            let indexTo = num * page
            indexTo =
                indexTo < filteredCoupons.length
                    ? indexTo
                    : filteredCoupons.length
            const finalCoupons = filterServerSide
                ? filteredCoupons
                : filteredCoupons.slice(indexFrom, indexTo)

            commit('setCoupons', finalCoupons)
            commit('setTotalRows', response.totalRows)

            return finalCoupons
        },
    },

    mutations: {
        setCoupons(state: any, coupons) {
            state.coupons = coupons
        },
        setTotalRows(state: any, rows: number) {
            state.totalRows = rows
        },
    },
}

export default couponModule
/* jscpd:ignore-end */
